export class TaskError extends Error {
    constructor(code, msg) {
        super(msg);
        this.code = code;
    }
    static operationCancelled(task) {
        return new TaskError(TaskError.Code.TASK_OPERATION_CANCELLED, `Operation cancelled`);
    }
}
(function (TaskError) {
    let Code;
    (function (Code) {
        Code["TASK_OPERATION_CANCELLED"] = "TASK_OPERATION_CANCELLED";
    })(Code = TaskError.Code || (TaskError.Code = {}));
})(TaskError || (TaskError = {}));
